import { useMutation, useQueryClient } from '@tanstack/react-query';

import { clearAmplitudeUserSession } from '~analytics/amplitude';
import { clearAiQuota } from '~shared/stores/aiQuotaStore';

import IntercomService from '../../../../intercom/IntercomService';
import { logout } from '../../../api/auth';

export function useLogout() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: logout,
    onMutate: () => {
      IntercomService.shutdown();
      clearAmplitudeUserSession();
      clearAiQuota();
      queryClient.removeQueries();
      window.pubnub.unsubscribeAll();
    },
  });
}
